<template>
    <layout-fullwidth>
        <div class="marketing-page">
            <div class="header-marketing mb-3 mb-md-0">
                <div class="header-marketing-text row no-gutters text-center position-relative overflow-hidden">
                    <div class="col">
                        <div class="row now-gutters my-4 my-lg-5">
                            <div class="col">
                                <router-link :to="{ name: 'portal.home' }" class="">
                                    <img class="img-fluid" alt="Logo" :src="assetsPathGlobalPlatform('/logo.svg')" width="140px" height="120px">
                                </router-link>
                            </div>
                        </div>
                        <div class="row now-gutters">
                            <div class="col-12 col-md-9 col-lg-8 mx-auto">
                                <p class="lead">Gerir o município agora é mais fácil</p>
                                <h2>Proporcione aos munícipes o melhor do município</h2>
                            </div>
                        </div>
                        <div class="row now-gutters">
                            <div class="col mx-auto">
                                <router-link :to="{ name: 'portal.contact-us' }" class="">
                                    <button type="button" class="btn btn-main btn-rounded btn-lg">{{ buy }}</button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row now-gutters header-marketing-img">
                    <div class="col-12 text-center">
                        <router-link :to="{ name: 'portal.contact-us' }" class="">
                            <img class="img-fluid" alt="" :src="assetsPathModule('/pic-0.png')">
                        </router-link>
                    </div>
                </div>
            </div>

            <section class="showcase">
                <div class="container-fluid">
                    <div class="row no-gutters mb-lg-5">
                        <div class="col-12 col-lg-6 mb-3 my-lg-auto showcase-text">
                            <router-link :to="{ name: 'portal.contact-us' }" class="">
                                <div class="title mb-4">Território</div>
                            </router-link>
                            <div class="heading mb-4">Interaja com o Município através do mapa</div>
                            <p class="lead mb-0">Serviços on-line de base geográfica à disposição da população e das equipas do Município.</p>
                        </div>
                        <div class="col-12 col-lg-6 text-white showcase-img d-flex align-items-center justify-content-center">
                            <router-link :to="{ name: 'portal.contact-us' }" class="">
                                <img class="img-fluid" alt="Mapa" :src="assetsPathModule('/pic-1.png')">
                            </router-link>
                        </div>
                    </div>
                    <div class="row no-gutters marketing">
                        <div class="col-12 col-lg-6 order-lg-2 mb-3 my-lg-auto text-white showcase-img d-flex align-items-center justify-content-center">
                            <router-link :to="{ name: 'portal.contact-us' }" class="">
                                <img class="img-fluid" alt="Mapa" :src="assetsPathModule('/pic-4.png')">
                            </router-link>
                        </div>
                        <div class="col-12 col-lg-6 order-lg-1 mb-3 my-lg-auto showcase-text">
                            <div class="heading mb-4">A app para gestão inteligente do território</div>
                            <p class="lead mb-3">As pessoas vão poder aceder aos serviços sem sair de casa. A gestão e o Município é de todos.</p>
                            <div class="col-12 col-md-5 col-lg-4 px-0">
                                <router-link :to="{ name: 'portal.contact-us' }" class="">
                                    <button type="button" class="btn btn-main btn-rounded btn-block btn-md">{{ buy }}</button>
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-12 col-lg-7 order-2 order-lg-1 text-white showcase-img d-flex align-items-center justify-content-center">
                            <router-link :to="{ name: 'portal.contact-us' }" class="">
                                <img class="img-fluid" alt="Mapa" :src="assetsPathModule('/pic-2.png')">
                            </router-link>
                        </div>
                        <div class="col-12 col-lg-5 order-1 order-lg-2 mb-3 my-lg-auto showcase-text">
                            <router-link :to="{ name: 'portal.contact-us' }" class="">
                                <div class="title mb-4">Relatórios</div>
                            </router-link>
                            <div class="heading mb-4">Todos os dados disponíveis num só ecrã</div>
                            <p class="lead mb-0">Direto, prático, operacional e funcional.</p>
                        </div>
                    </div>
                    <div class="row no-gutters">
                        <div class="col-12 col-lg-7 order-2 text-white showcase-img d-flex align-items-center justify-content-center">
                            <router-link :to="{ name: 'portal.contact-us' }" class="">
                                <img class="img-fluid" alt="Mapa" :src="assetsPathModule('/pic-3.png')">
                            </router-link>
                        </div>
                        <div class="col-12 col-lg-5 order-1 order-lg-1 mb-3 my-lg-auto showcase-text">
                            <router-link :to="{ name: 'portal.contact-us' }" class="">
                                <div class="title mb-4">Personalização</div>
                            </router-link>
                            <div class="heading mb-4">Escalável em função das necessidades de gestão</div>
                            <p class="lead mb-0">Ajustado à complexidade das suas operações diárias.</p>
                        </div>
                    </div>
                </div>
            </section>

            <footer class="footer-marketing">
                <div class="container-fluid">
                    <div class="row m-sm-0 p-sm-0">
                        <div class="col-12 col-md-auto d-flex flex-sm-column align-items-sm-start justify-content-between">
                            <img class="img-fluid img-logo" alt="Logo" :src="assetsPathGlobalPlatform('/logo-1.svg')">
                            <a class="d-none d-sm-block" href="https://www.municipia.pt" target="_blank">
                                <img class="img-fluid img-municipia" alt="Municipia" :src="LogoIcon">
                            </a>
                            <router-link :to="{ name: 'portal.contact-us' }" class="d-block d-sm-none">
                                <button type="button" class="btn btn-main btn-rounded btn-sm my-0">{{ buy }}</button>
                            </router-link>
                        </div>
                        <div class="col-12 col-md mx-auto">
                            <div class="row">
                                <div class="col-12 col-sm-9 col-lg-7 mx-auto ">
                                    <p>Plataforma centralizadora de soluções digitais que, através da localização, permite ao munícipe aceder a serviços sem sair de casa e ao município garantir a prestação de serviços à população com melhor qualidade e celeridade.</p>
                                    <router-link :to="{ name: 'portal.contact-us' }" class="d-none d-sm-block">
                                        <button type="button" class="btn btn-main btn-rounded btn-sm mx-0">{{ buy }}</button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-auto">
                            <div class="">
                              <ul class="list list-unstyled font-small">
                                <li class="list-item"><a class="" href="https://www.municipia.pt" target="_blank">Sobre a municípia</a></li>
                                <li class="list-item">
                                    <router-link :to="{ name: 'portal.contact-us' }" class="">
                                        Contatos
                                    </router-link>
                                </li>
                                <!-- <li class="list-item">
                                    <router-link :to="{ name: 'portal.help' }" class="">
                                        Ajuda
                                    </router-link>
                                </li> -->
                              </ul>
                            </div>
                        </div>
                        <div class="col-12 d-sm-none text-center">
                            <a class="" href="https://www.municipia.pt" target="_blank">
                                <img class="img-fluid img-municipia small" alt="Municipia" :src="LogoIcon">
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </layout-fullwidth>
</template>

<script>
    import mixin from '../mixin'
    import LayoutFullWidth from '../layouts/Full.vue'
    import LogoWhiteIcon from '@images/logo-municipia-white.png';

    export default {
        mixins: [mixin],
        components: {
            LayoutFullwidth: LayoutFullWidth,
        },
        data() {
            return {
                buy: 'Aderir',
                notifications: [],
            }
        },
        computed: {
            logoIcon() {
                return LogoWhiteIcon;
            },
        }
    }
</script>

<style lang="scss">
@import "@styles/_theme.scss";

.header-marketing-text {
    background-image: url('../images/themes/#{$theme-name}/bg-top.svg');
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>